
import { Component, OnInit, ViewContainerRef, ViewChild, Input, OnDestroy, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { map, Observable, Subscription } from 'rxjs';
import { MessageService } from 'src/app/common/message.service';
import { HTTPService } from 'src/app/services/http.service';
import { SharedService } from 'src/app/services/shared.service';
import { HttpClient } from '@angular/common/http';
import * as PDFObject from 'pdfobject';

declare function unescape(s: string): string;

declare var $: any;

// $.navigation = $('#header-menu');
@Component({
  selector: 'HowItWorks',
  templateUrl: './howitworks.component.html',
  styleUrls: ['./howitworks.component.css'],
  providers: [HTTPService, MessageService]
})


export class HowItWorksComponent implements OnInit, OnDestroy {
  subscription = new Subscription();
  public videoPath;
  @Input() userVideoId;
  @Input() UserId;
  @Input() displayType;
  @Input() previewStyle = '';
  @Input() invitationType;
  @Input() documentPath;
  safeDocumentPath: any;
  @ViewChild('pdfViewer') pdfViewer: ElementRef;

  constructor(private _httpService: HTTPService, private activeModel: NgbActiveModal, private dialog: MatDialog,
    private _router: Router, private _route: ActivatedRoute,
    private messageService: MessageService, public toastr: ToastrService, vcr: ViewContainerRef,
    public sanitizer: DomSanitizer, private sharedService: SharedService, private http: HttpClient) {

  }

  ngOnInit() {
    if (this.invitationType == 1) {
      this.downloadPreview().subscribe(
        (videoURL: string) => {
          this.videoPath = videoURL;
        },
        (error) => {
          console.error('Error downloading video:', error);
        }
      );
    }
    else {
      this.safeDocumentPath = this.sanitizer.bypassSecurityTrustResourceUrl(this.documentPath);
    }
  }
  ngAfterViewInit() {
    setTimeout(() => {
      const pdfUrl = this.documentPath;
      if (this.pdfViewer != undefined)
        PDFObject.embed(pdfUrl, this.pdfViewer.nativeElement);
    }, 2000);
  }
  payAndDownload() {
    if (
      this.videoPath.length !== 0 ||
      this.videoPath.length !== 0
    ) {
      this.sharedService.isShowLoader.next(true);
      let objLog = Object.assign({});
      objLog.UserId = this.UserId;
      objLog.MethodName = "Pay & Downlaod Popup";
      objLog.IsSuccess = true;
      objLog.Description = `User clicked download => ${this.videoPath}`;
      objLog.IPAddress = this.sharedService.ipAddress;
      this.subscription.add(
        this._httpService.ajaxPost('Personalize/AddLog', objLog).subscribe((data) => {
          this.activeModel.close(true);
          this.dialog.closeAll();
          this.sharedService.isShowLoader.next(false);
        }));
    }
    else {
      this.toastr.warning(
        'Preview Video Failed!! Please generate the preview video first and then you can proceed for payment.'
      );
    }
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  closeModal() {
    this.activeModel.close();
    this.dialog.closeAll();
  }
  downloadPreview(): Observable<string> {
    return this.http
      .get(this.videoPath, { responseType: 'blob' })
      .pipe(
        map((videoBlob: Blob) => URL.createObjectURL(videoBlob))
      );
  }
}
